import { UserLayer } from '@lowcodeunit/lcu-map-common/lib/models/user-layer.model';
import { MapMarker } from '@lowcodeunit/lcu-map-common';
import { ItineraryModel } from '../../models/itinerary.model';
import { UserAlbum } from '../../models/user-album.model';
import { TopListModel } from '../../models/top-list.model';
import { UserInfo } from '../../models/user-info.model';
import { Status } from '@lcu/common';

export class UsersState {
  public Loading?: boolean;

  public PrimaryMapID?: string;

  public SelectedMapIDs?: any[];

  public SelectedMapLocations?: any[];

  public UserMaps?: any[];

  public UserAccolades: {
    LocationID: string,
    Lookup: string,
    Rank: string, 
    Title: string, 
    Year: string };

  public SelectedUserMapID: number;

  public VisibleUserLocations: Array<MapMarker>;

  public SelectedUserLayerIDs: Array<number>;

  public UserLayers: Array<UserLayer>;

  public UserItineraries: Array<ItineraryModel>;

  public UserAlbums: Array<UserAlbum>;

  public UserInfo: UserInfo;

  public Error: string;

  public SharedStatus: Status;

  public LocalSearchUserLocations: Array<MapMarker>;

  public OtherSearchUserLocations: Array<MapMarker>;

  public UserTopLists: Array<TopListModel>;

  public StateType: string;

  public ExcludedCuratedLocations: {
    Created: any
    ID: string
    LocationIDs: string
    Modified: any
    PartitionKey: any};

}
